import React from 'react';
import { Link } from 'react-router-dom';
import { routePaths } from '@css-xp/ppc-constants';
import { getRouteUrl } from '@css-xp/ppc-utils';

export interface RefundDetailsLinkProps {
  refundNumber: string;
  txaId: string;
}

export const RefundDetailsLink = ({ refundNumber, txaId }: RefundDetailsLinkProps) => {
  return (
    <Link
      className={'refund-link'}
      data-testid={`refund-url-${refundNumber}`}
      to={getRouteUrl(routePaths.refundDetails, {
        txaId: txaId,
        refundId: refundNumber,
      })}
      onClick={(e) => e.stopPropagation()}
    >
      {refundNumber}
    </Link>
  );
};
